// src/pages/Statements/Pagination.jsx
import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, totalItems, pageSize, onChange }) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end   = Math.min(totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem   = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="stmt-pagination">
      <span className="stmt-pagination-info">
        Showing <strong>{startItem}–{endItem}</strong> of <strong>{totalItems}</strong>
      </span>

      <div className="stmt-pagination-controls">
        <button
          className="stmt-page-btn"
          onClick={() => onChange(1)}
          disabled={currentPage === 1}
          title="First page"
        >«</button>
        <button
          className="stmt-page-btn"
          onClick={() => onChange(currentPage - 1)}
          disabled={currentPage === 1}
          title="Previous page"
        >‹</button>

        {getPageNumbers().map(p => (
          <button
            key={p}
            className={`stmt-page-btn ${p === currentPage ? 'active' : ''}`}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        ))}

        <button
          className="stmt-page-btn"
          onClick={() => onChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          title="Next page"
        >›</button>
        <button
          className="stmt-page-btn"
          onClick={() => onChange(totalPages)}
          disabled={currentPage === totalPages}
          title="Last page"
        >»</button>
      </div>
    </div>
  );
};

export default Pagination;